// Throw this when an action should be cancelled (e.g. due to no network, page reloading)
// and no useful data can be returned to the caller, but the error should NOT be logged.
export class CancelError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class ApplicationError extends Error {
  constructor(name, message, userMessage, contexts) {
    super(message);
    this.name = name;
    this.userMessage = userMessage;
    this.contexts = contexts;
  }
}

export class BackendError extends ApplicationError {
  constructor(endpoint, message, userMessage, request, response) {
    super(`BackendError: ${message}`, `Server call unsuccessful to ${endpoint}`, userMessage, {
      request,
      response,
    });
  }

  static fromHttpResponse(response) {
    return new BackendError(
      response.config.url || "unknown",
      response.data.error?.message || response.data.error?.code || "unknown",
      response.data.error?.message || "Could not execute this action",
      requestData(response.config),
      responseData(response),
    );
  }

  static fromHttpError(error) {
    return new BackendError(
      error.config.url || "unknown",
      error.code || "unknown",
      error.message || "Could not execute this action",
      requestData(error.config),
    );
  }

  get response() {
    return this.contexts.response;
  }
}

function responseData(res) {
  return {
    httpStatus: res.status,
    httpStatusText: res.statusText,
    status: res.data.status,
    code: res.data.error?.code || "unknown",
    data: res.data.data,
    raw: res.data,
  };
}

function requestData(config) {
  return {
    baseUrl: config.baseURL,
    url: config.url,
    headers: config.headers,
  };
}
